import React, { useState, useEffect } from 'react';
import { getConfig } from '../config/gameConfig';

const DebugOverlay = () => {
  const [dimensions, setDimensions] = useState({
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    devicePixelRatio: window.devicePixelRatio || 1,
    orientation: window.screen.orientation?.type || 'unknown'
  });

  useEffect(() => {
    const updateDimensions = () => {
      setDimensions({
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        devicePixelRatio: window.devicePixelRatio || 1,
        orientation: window.screen.orientation?.type || 'unknown'
      });
    };

    window.addEventListener('resize', updateDimensions);
    window.addEventListener('orientationchange', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
      window.removeEventListener('orientationchange', updateDimensions);
    };
  }, []);

  // Check URL parameter for debug override
  const urlParams = new URLSearchParams(window.location.search);
  const debugParam = urlParams.get('debug');
  
  // URL parameter overrides config setting
  // ?debug=true or ?debug=1 enables it
  // ?debug=false or ?debug=0 disables it
  // If no URL param, fall back to config
  let isDebugEnabled = getConfig('debugMode');
  
  if (debugParam !== null) {
    isDebugEnabled = debugParam === 'true' || debugParam === '1';
  }

  // Only show if debug mode is enabled
  if (!isDebugEnabled) {
    return null;
  }

  // Determine breakpoint
  const getBreakpoint = (width) => {
    if (width <= 380) return '≤380px (Extra Small)';
    if (width <= 767) return '≤767px (Mobile)';
    if (width <= 1024) return '≤1024px (Tablet)';
    if (width <= 1440) return '≤1440px (Desktop)';
    return '≥1441px (Large Desktop)';
  };

  const breakpoint = getBreakpoint(dimensions.viewportWidth);
  const baseFontSize = dimensions.viewportWidth <= 380 ? '13px' :
                       dimensions.viewportWidth <= 767 ? '14px' :
                       dimensions.viewportWidth >= 1441 ? '18px' : '16px';

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      color: '#00ff00',
      padding: '12px 16px',
      borderRadius: '8px',
      fontSize: '11px',
      fontFamily: 'monospace',
      zIndex: 99999,
      border: '1px solid rgba(0, 255, 0, 0.4)',
      boxShadow: '0 4px 12px rgba(0, 255, 0, 0.15)',
      minWidth: '220px',
      lineHeight: '1.6',
      /*backdropFilter: 'blur(10px)',*/
      pointerEvents: 'none', // Don't block interactions
      userSelect: 'none',
      textShadow: '0 0 8px rgba(0, 0, 0, 0.8), 0 1px 2px rgba(0, 0, 0, 1)' // Make text readable despite transparency
    }}>
      <div style={{ 
        fontWeight: 'bold', 
        marginBottom: '8px', 
        fontSize: '12px',
        color: '#00ffff',
        borderBottom: '1px solid #00ff00',
        paddingBottom: '4px'
      }}>
        🔍 DEBUG MODE
      </div>
      
      <div style={{ marginBottom: '4px' }}>
        <strong style={{ color: '#ffff00' }}>Viewport:</strong> {dimensions.viewportWidth} × {dimensions.viewportHeight}px
      </div>
      
      <div style={{ marginBottom: '4px' }}>
        <strong style={{ color: '#ffff00' }}>Screen:</strong> {dimensions.screenWidth} × {dimensions.screenHeight}px
      </div>
      
      <div style={{ marginBottom: '4px' }}>
        <strong style={{ color: '#ffff00' }}>DPR:</strong> {dimensions.devicePixelRatio}x
      </div>
      
      <div style={{ marginBottom: '4px' }}>
        <strong style={{ color: '#ffff00' }}>Orientation:</strong> {dimensions.orientation}
      </div>
      
      <div style={{ 
        marginTop: '8px', 
        paddingTop: '8px', 
        borderTop: '1px solid #00ff00' 
      }}>
        <div style={{ color: '#ff8800', fontWeight: 'bold', marginBottom: '2px' }}>
          {breakpoint}
        </div>
        <div style={{ color: '#888', fontSize: '10px' }}>
          Base Font: {baseFontSize}
        </div>
      </div>
    </div>
  );
};

export default DebugOverlay;

